var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9525 9.65625L28.4875 4.5325C27.725 1.86375 25.2525 0 22.4775 0H21.25V5C21.2425 6.635 18.7563 6.63375 18.75 5V0H11.25V5C11.2425 6.635 8.7575 6.63375 8.75 5V0H7.52125C4.74625 0 2.275 1.86375 1.51125 4.5325L0.0487524 9.65625C-0.152498 10.9887 0.441252 12.3287 1.25 13.2725V25C1.25 27.7575 3.4925 30 6.25 30H13.75C16.5075 30 18.75 27.7575 18.75 25V14.305C19.2225 14.0288 19.6425 13.6825 20 13.2725C20.9175 14.3225 22.2488 15 23.75 15H25C25.4338 15 25.8475 14.9275 26.25 14.8225V28.75C26.2575 30.385 28.7438 30.3838 28.75 28.75V13.2725C29.56 12.33 30.1525 10.99 29.9525 9.65625ZM16.25 21.25H3.75V14.8225C4.1525 14.9275 4.56625 15 5 15H6.25C7.75 15 9.0825 14.3225 10 13.2725C10.9175 14.3225 12.25 15 13.75 15H16.25V21.25Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.316a18ab.svg";
export { ForwardRef as ReactComponent };